module.exports = __webpack_public_path__ + "img/logo-blonk@2x.png";